import { Dialog, Select, MenuItem } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import { observer } from 'mobx-react-lite';
import React, { FC, useEffect } from 'react';
import { useMask } from '@react-input/mask';
import { useService } from '~/services/service.base';
import { DialogService } from '~/services/service.dialog';
import { DropdownArrow } from '~/views/atoms/svg-icons/dropdown-arrow';
import { CodeVerification } from '~/views/molecules/code.verification';
import { UnityErrorDialog } from '~/views/molecules/unity.error.dialog';

export const LinkAccountDialog: FC = observer(() => {
    const dialogService = useService(DialogService);
    const { linkAccountDialogSrv } = dialogService;
    const dateOfBirthRef = useMask({ mask: '__/__/____', replacement: { _: /\d/ } });
    const dateOfBirthLinkRef = useMask({ mask: '__/__/____', replacement: { _: /\d/ } });

    useEffect(() => {
        window.addEventListener('keyup', linkAccountDialogSrv.onStepKeyUp);
    }, []);

    const onUnityErrorButtonClick = () => {
        linkAccountDialogSrv.setLinkUnityAuthError(false);
    };

    return (
        <React.Fragment>
            <Dialog open={linkAccountDialogSrv.open} className="hr-modal-dialog link-unity-modal">
                {linkAccountDialogSrv.showStep1 && (
                    <div className="modal-dialog modal-dialog-centered step1">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={linkAccountDialogSrv.handleClose}>
                                    <figure>
                                        <img src="/assets/img/modal-close-btn.svg" />
                                    </figure>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="modalContent">
                                    <div className="unity-logo-wrap-modal">
                                        <figure>
                                            <img className="unity-logo-modal" src="/assets/img/unity-logo-modal.svg" />
                                            <img
                                                className="unity-logo-modal-mobile"
                                                src="/assets/img/unity-logo-modal-mobile.svg"
                                            />
                                        </figure>
                                    </div>
                                    <h3>Link or sign up for a Unity Account To Redeem your Free Play credits!</h3>
                                    <div className="link-unity-btns-wrap">
                                        <div className="sign-up-unity-btn-wrap">
                                            <button
                                                type="button"
                                                id="sign-up-unity-btn"
                                                onClick={linkAccountDialogSrv.handleOpenSignUp}
                                                className="btn"
                                            >
                                                Sign Up
                                            </button>
                                        </div>
                                        <div className="link-unity-btn-wrap">
                                            <button
                                                type="button"
                                                id="link-unity-btn"
                                                className="btn"
                                                onClick={linkAccountDialogSrv.handleOpenLinkAccount}
                                            >
                                                Link Account
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {linkAccountDialogSrv.showSignUp && (
                    <div className="modal-dialog modal-dialog-centered step2-create-account">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={linkAccountDialogSrv.handleClose}>
                                    <figure>
                                        <img src="/assets/img/modal-close-btn.svg" />
                                    </figure>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="modalContent">
                                    {linkAccountDialogSrv.showLoading ? <LinearProgress /> : null}
                                    <div className="unity-logo-wrap-modal">
                                        <figure>
                                            <img className="unity-logo-modal" src="/assets/img/unity-logo-modal.svg" />
                                            <img
                                                className="unity-logo-modal-mobile"
                                                src="/assets/img/unity-logo-modal-mobile.svg"
                                            />
                                        </figure>
                                    </div>
                                    <h3>Create Account</h3>
                                    <div className="unity-form-wrap">
                                        <div className="unity-form-row">
                                            <div
                                                className={
                                                    'unity-form-item' +
                                                    (linkAccountDialogSrv.isFirstNameInvalid
                                                        ? ' create-unity-error'
                                                        : '')
                                                }
                                            >
                                                <label htmlFor="first-name" className="form-label">
                                                    First Name *
                                                </label>
                                                <input
                                                    id="first-name"
                                                    className="form-control create-account"
                                                    name="first-name"
                                                    type="text"
                                                    autoComplete="off"
                                                    onBlur={linkAccountDialogSrv.handleFirstNameBlur}
                                                    onFocus={linkAccountDialogSrv.handleFirstNameFocus}
                                                    defaultValue={linkAccountDialogSrv.account.firstName || ''}
                                                    maxLength={50}
                                                />
                                                <div className="invalid-format-error-msg">Invalid format</div>
                                            </div>
                                            <div
                                                className={
                                                    'unity-form-item' +
                                                    (linkAccountDialogSrv.isLastNameInvalid
                                                        ? ' create-unity-error'
                                                        : '')
                                                }
                                            >
                                                <label htmlFor="last-name" className="form-label">
                                                    Last Name *
                                                </label>
                                                <input
                                                    id="last-name"
                                                    className="form-control create-account"
                                                    name="last-name"
                                                    type="text"
                                                    autoComplete="off"
                                                    onBlur={linkAccountDialogSrv.handleLastNameBlur}
                                                    onFocus={linkAccountDialogSrv.handleLastNameFocus}
                                                    defaultValue={linkAccountDialogSrv.account.lastName || ''}
                                                    maxLength={50}
                                                />
                                                <div className="invalid-format-error-msg">Invalid format</div>
                                            </div>
                                        </div>
                                        <div className="unity-form-row">
                                            <div
                                                className={
                                                    'unity-form-item' +
                                                    (linkAccountDialogSrv.isDateOfBirthInvalid
                                                        ? ' create-unity-error'
                                                        : '')
                                                }
                                            >
                                                <label htmlFor="date-birth" className="form-label">
                                                    Date of birth *
                                                </label>
                                                <input
                                                    id="date-birth"
                                                    className="form-control create-account"
                                                    name="date-birth"
                                                    placeholder="MM/DD/YYYY"
                                                    autoComplete="off"
                                                    ref={dateOfBirthRef}
                                                    type="text"
                                                    onBlur={linkAccountDialogSrv.handleDateOfBirthBlur}
                                                    onFocus={linkAccountDialogSrv.handleDateOfBirthFocus}
                                                    defaultValue={linkAccountDialogSrv.account.dateBirth || ''}
                                                />
                                                <div className="date-birth-error-msg">Date of birth is not valid</div>
                                            </div>
                                            <div className="unity-form-item unity-countries-wrap">
                                                <div>
                                                    <label htmlFor="unity-countries-dropdown" className="form-label">
                                                        select country *
                                                    </label>
                                                </div>
                                                <Select
                                                    className="hr-select"
                                                    IconComponent={DropdownArrow}
                                                    value={linkAccountDialogSrv.selectedCountry}
                                                    onChange={linkAccountDialogSrv.handleCountryChange}
                                                >
                                                    <MenuItem className="link-account-menu" value={'0'}></MenuItem>
                                                    {linkAccountDialogSrv.countries.map(country => (
                                                        <MenuItem key={country.id} value={country.id}>
                                                            {country.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </div>
                                        </div>
                                        <div className="unity-form-row">
                                            <div
                                                className={
                                                    'unity-form-item' +
                                                    (linkAccountDialogSrv.isEmailInvalid ? ' create-unity-error' : '')
                                                }
                                            >
                                                <label htmlFor="email-unity" className="form-label">
                                                    Email *
                                                </label>
                                                <input
                                                    id="email-unity"
                                                    className="form-control email-input"
                                                    name="email-unity"
                                                    type="text"
                                                    autoComplete="off"
                                                    onBlur={linkAccountDialogSrv.handleEmailBlur}
                                                    onFocus={linkAccountDialogSrv.handleEmailFocus}
                                                    defaultValue={linkAccountDialogSrv.account.email || ''}
                                                    maxLength={50}
                                                />
                                            </div>
                                            <div
                                                className={
                                                    'unity-form-item unity-phone-item' +
                                                    (linkAccountDialogSrv.isPhoneInvalid ? ' create-unity-error' : '')
                                                }
                                            >
                                                <label htmlFor="phone-unity" className="form-label">
                                                    Phone
                                                </label>
                                                <span className="span-label"> (optional)</span>
                                                <input
                                                    id="phone-unity"
                                                    className="form-control"
                                                    name="phone-unity"
                                                    type="text"
                                                    onBlur={linkAccountDialogSrv.handlePhoneNumberBlur}
                                                    onFocus={linkAccountDialogSrv.handlePhoneNumberFocus}
                                                    maxLength={50}
                                                />
                                                <div className="phone-error-msg hide">Mobile number is not valid</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="unity-agree-wrap">
                                        <p>
                                            Registrants must be over 18 years old and form must be completed to sign up.
                                        </p>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                checked={linkAccountDialogSrv.isAgreeOneChecked}
                                                id="unity-agree-one"
                                                onChange={linkAccountDialogSrv.handleAgreeOneChange}
                                            />
                                            <label className="form-check-label" htmlFor="unity-agree-one">
                                                I agree to opt in to marketing communications from Unity and Hard Rock.
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                checked={linkAccountDialogSrv.isAgreeTwoChecked}
                                                id="unity-agree-two"
                                                onChange={linkAccountDialogSrv.handleAgreeTwoChange}
                                            />
                                            <label className="form-check-label" htmlFor="unity-agree-two">
                                                I have read and agreed to the&nbsp;
                                                <a
                                                    href="https://unity.hardrock.com/policies/loyalty-rewards-program-terms-and-conditions"
                                                    target="_blank"
                                                    role="button"
                                                    rel="noreferrer"
                                                >
                                                    Unity Program Terms of Service
                                                </a>
                                                &nbsp;and&nbsp;
                                                <a
                                                    href="https://unity.hardrock.com/policies/privacy"
                                                    role="button"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Privacy Policy
                                                </a>
                                            </label>
                                            {/* <label className="form-check-label" htmlFor="unity-agree-two">
                                                I have read and agreed to the&nbsp;
                                                <a
                                                    href="#"
                                                    onClick={e =>
                                                        privacyPolicyDialogSrv.handleOpen(
                                                            e,
                                                            linkAccountDialogSrv.unityDocuments,
                                                            UnityDocumentType.terms,
                                                        )
                                                    }
                                                    role="button"
                                                >
                                                    Unity Program Terms of Service
                                                </a>
                                                &nbsp;and&nbsp;
                                                <a
                                                    href="#"
                                                    onClick={e =>
                                                        privacyPolicyDialogSrv.handleOpen(
                                                            e,
                                                            linkAccountDialogSrv.unityDocuments,
                                                            UnityDocumentType.privacy,
                                                        )
                                                    }
                                                    role="button"
                                                >
                                                    Privacy Policy
                                                </a>
                                            </label> */}
                                        </div>
                                    </div>
                                    <div className="sign-up-unity-btn-wrap">
                                        <button
                                            type="button"
                                            id="sign-up-unity-btn2"
                                            onClick={linkAccountDialogSrv.unitySignUp}
                                            disabled={linkAccountDialogSrv.isCreateAccountBtnDisabled}
                                            className="btn"
                                        >
                                            Sign Up
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {linkAccountDialogSrv.showLinkAccount && (
                    <div className="modal-dialog modal-dialog-centered step3-link-account">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={linkAccountDialogSrv.handleClose}>
                                    <figure>
                                        <img src="/assets/img/modal-close-btn.svg" />
                                    </figure>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="modalContent">
                                    {linkAccountDialogSrv.showLoading ? <LinearProgress /> : null}
                                    <div className="unity-logo-wrap-modal">
                                        <figure>
                                            <img className="unity-logo-modal" src="/assets/img/unity-logo-modal.svg" />
                                            <img
                                                className="unity-logo-modal-mobile"
                                                src="/assets/img/unity-logo-modal-mobile.svg"
                                            />
                                        </figure>
                                    </div>
                                    <h3>Link Your Unity Account</h3>
                                    <div className="unity-form-wrap">
                                        <div
                                            className={
                                                'unity-form-item' +
                                                (linkAccountDialogSrv.isLinkUnityEmailInvalid
                                                    ? ' create-unity-error'
                                                    : '')
                                            }
                                        >
                                            <label htmlFor="unity-account-email" className="form-label">
                                                email address *
                                            </label>
                                            <input
                                                id="unity-account-email"
                                                className="form-control"
                                                name="unity-account-email"
                                                autoComplete="off"
                                                type="text"
                                                onBlur={linkAccountDialogSrv.handleUnityEmailBlur}
                                                defaultValue={linkAccountDialogSrv.linkAccount.unityAccountEmail || ''}
                                                maxLength={50}
                                            />
                                        </div>
                                        <div
                                            className={
                                                'unity-form-item' +
                                                (linkAccountDialogSrv.isDateOfBirthLinkInvalid
                                                    ? ' create-unity-error'
                                                    : '')
                                            }
                                        >
                                            <label htmlFor="date-of-birth" className="form-label">
                                                Date of birth *
                                            </label>
                                            <input
                                                id="date-of-birth"
                                                className="form-control"
                                                name="date-of-birth"
                                                type="text"
                                                autoComplete="off"
                                                placeholder="MM/DD/YYYY"
                                                ref={dateOfBirthLinkRef}
                                                onChange={linkAccountDialogSrv.handleDateOfBirthLinkChange}
                                                onFocus={linkAccountDialogSrv.handleDateOfBirthLinkFocus}
                                                defaultValue={linkAccountDialogSrv.linkAccount.dateBirth || ''}
                                            />
                                        </div>
                                    </div>
                                    <div className="link-unity-btn-wrap">
                                        <button
                                            type="button"
                                            id="link-unity-btn2"
                                            className="btn"
                                            onClick={linkAccountDialogSrv.handleOpenStep3}
                                            disabled={linkAccountDialogSrv.isLinkAccountBtnDisabled}
                                        >
                                            Link Account
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {(linkAccountDialogSrv.showNotSuccess || linkAccountDialogSrv.showActivate) && (
                    <div className="modal-dialog modal-dialog-centered step3-link-account not-success">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={linkAccountDialogSrv.handleClose}>
                                    <figure>
                                        <img src="/assets/img/modal-close-btn.svg" />
                                    </figure>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div
                                    className={
                                        'modalContent' + (linkAccountDialogSrv.showActivate ? ' show-activate' : '')
                                    }
                                >
                                    <div className="unity-logo-wrap-modal">
                                        <figure>
                                            <img className="unity-logo-modal" src="/assets/img/unity-logo-modal.svg" />
                                            <img
                                                className="unity-logo-modal-mobile"
                                                src="/assets/img/unity-logo-modal-mobile.svg"
                                            />
                                        </figure>
                                    </div>
                                    <h3>Oops</h3>
                                    <div className="unity-form-wrap">
                                        {linkAccountDialogSrv.showNotSuccess && (
                                            <>
                                                {linkAccountDialogSrv.lastError.description ? (
                                                    <p>
                                                        {linkAccountDialogSrv.lastError.description} <br />
                                                        Please contact Unity Customer Care for assistance at
                                                    </p>
                                                ) : (
                                                    <p>
                                                        There was an issue authenticating. <br />
                                                        Please contact Unity Customer Care for assistance at
                                                    </p>
                                                )}
                                                <p className="not-success-mail">
                                                    <a href="mailto:customercare@unitybyhardrock.com">
                                                        customercare@unitybyhardrock.com
                                                    </a>
                                                </p>
                                            </>
                                        )}
                                        {linkAccountDialogSrv.showActivate && (
                                            <>
                                                {linkAccountDialogSrv.lastError.description ? (
                                                    <p>{linkAccountDialogSrv.lastError.description}</p>
                                                ) : (
                                                    <p>
                                                        Your Account Has Not Yet Been Activated. <br />
                                                        Please Check Your Inbox For The Activation Email. <br />
                                                        To Send A New Activation Email, <br />
                                                        Click “Activate” Below.
                                                    </p>
                                                )}
                                            </>
                                        )}
                                    </div>
                                    <div className="link-unity-btn-wrap">
                                        {linkAccountDialogSrv.showNotSuccess && (
                                            <button
                                                type="button"
                                                id="link-unity-btn2"
                                                className="btn"
                                                onClick={linkAccountDialogSrv.handleClose}
                                            >
                                                OK
                                            </button>
                                        )}
                                        {linkAccountDialogSrv.showActivate && (
                                            <button
                                                type="button"
                                                id="link-unity-btn2"
                                                className="btn"
                                                onClick={linkAccountDialogSrv.activateResend}
                                            >
                                                Activate
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {linkAccountDialogSrv.showStep3 && (
                    <div className="modal-dialog modal-dialog-centered link-account-verification">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={linkAccountDialogSrv.handleClose}>
                                    <figure>
                                        <img src="/assets/img/modal-close-btn.svg" />
                                    </figure>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="modalContent">
                                    <CodeVerification
                                        onSendVerificationCode={linkAccountDialogSrv.sendVerificationCode}
                                        onEnterVerificationCode={linkAccountDialogSrv.afterEnterCode}
                                    >
                                        We’ve sent a 6-digit code to the email
                                        <br />
                                        linked to your Unity account.
                                    </CodeVerification>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Dialog>
            {linkAccountDialogSrv.isLinkUnityAuthError && (
                <UnityErrorDialog error={linkAccountDialogSrv.lastError} onButtonClick={onUnityErrorButtonClick} />
            )}
        </React.Fragment>
    );
});
